module.exports = __webpack_public_path__ + "img/checkout_preview.776f89c7.svg";